export const isNotNull = <T>(arg: T | null): arg is T => arg !== null;
export const isNotUndefined = <T>(arg: T | undefined): arg is T =>
  arg !== undefined;
export const isNotNullish = <T>(arg: T | null | undefined): arg is T =>
  isNotNull(arg) && isNotUndefined(arg);

export const intersection = <T>(a1: T[], a2: T[]): T[] =>
  a1.filter((value) => a2.includes(value));
